import type { LineItem } from "~/features/cart/cart/models/CartData";
import { Card, styled } from "~/common/mui";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { CheckoutProductLine } from "./CheckoutProductLine";

import { CartProductLine } from "./CartProductLine";

import { type HousingProduct } from "~/domains/product/types/ProductData";

import { OptionalPartsEntrySummary } from "./OptionalPartsEntrySummary";

import { ProductService } from "~/features/addToCart/api/ProductService";

interface CartEntryProps {
  product: HousingProduct;
  lineItem: LineItem;
  editMode: boolean;
}

export const OptionalPartEntry = ({ product, lineItem, editMode }: CartEntryProps) => {
  const productDescriptor = ProductService.useProductDescriptor({
    productCode: product.product.code,
    priceReference: lineItem.priceReference,
  });

  let renderItem;
  if (editMode) {
    renderItem = (lineItem: LineItem, product: ProductDescriptor) => {
      return <EditableLineItem key={lineItem.pk} lineItem={lineItem} product={product} />;
    };
  } else {
    renderItem = (lineItem: LineItem, product: ProductDescriptor) => (
      <ViewableLineItem key={lineItem.pk} lineItem={lineItem} product={product} />
    );
  }

  return (
    <Card>
      <OptionalPartsEntrySummary product={productDescriptor} editMode={editMode} />
      {renderItem(lineItem, productDescriptor)}
    </Card>
  );
};

const EditableLineItem = styled(CartProductLine)(({ theme }) => ({
  border: "none",
  borderTop: "1px solid",
  borderRadius: 0,
  borderColor: theme.palette.divider,
}));

const ViewableLineItem = styled(CheckoutProductLine)(({ theme }) => ({
  border: "none",
  borderTop: "1px solid",
  borderRadius: 0,
  borderColor: theme.palette.divider,
}));
